import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import { useHttpClient } from "../../../shared/hooks/http-hook";
//MUI
import { DataGrid } from "@mui/x-data-grid";
import dataGridData from "./components/datagridData";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
/////////////////////////////////////////////////////
import FiltrosFinanceiro from "./components/filtros/FiltrosFinanceiro";
import SeletorUnidadeDados, {
  TODAS_UNIDADES,
} from "../../../shared/components/badgeUnidade/SeletorUnidadeDados";
import BadgeUnidade from "../../../shared/components/badgeUnidade/BadgeUnidade";
import { paramsUnidadeDados } from "../../../shared/util/unidadeRegisto";
import { dadosImpressao } from "../../../shared/util/dadosImpressao";
import { generateExcelFile } from "../../../shared/components/excelUtils/exportExcel";
import { somarAoMetodo } from "../../../shared/util/resumoPagamentos";
import { useLoading } from "../../../shared/context/LoadingContext";
import "../fluxoCaixa/FluxoCaixa.scss";

import { Popover } from "antd";

function FechoCaixa({
  clinicaId,
  auth,
  dadosFechoCaixa,
  showFatura,
  showRce,
  dadosClinica,
}) {
  const { startLoading, stopLoading } = useLoading();

  const [financialData, setFinancialData] = useState({
    totalRecebido: 0,
    totalReceber: 0,
    totalDespesas: 0,
    totalPorPagar: 0,
    saldo: 0,
  });

  const [dataFiltro, setDataFiltro] = useState({
    dataInicial: moment().format("DD/MM/YYYY"),
    dataFinal: moment().format("DD/MM/YYYY"),
  });

  const [resumoData, setResumoData] = useState({
    Dinheiro: 0,
    Cheque: 0,
    "Cheque Visado": 0,
    "Transferência de crédito": 0,
    "Internet banking": 0,
    "Cartão do banco": 0,
    "Débito direto da conta bancária": 0,
    "Cartão de crédito": 0,
    "Cartão de débito": 0,
  });

  const [instituicoes, setInstituicoes] = useState([]);
  const [rows, setRows] = useState([]);
  const [parcelas, setParcelas] = useState([]);
  const [parcelasAbsolut, setParcelasAbsolut] = useState([]);

  const [despesas, setDespesas] = useState([]);
  const [despesasAbsolut, setDespesasAbsolut] = useState([]);
  const [entradas, setEntradas] = useState([]);
  const [entradasAbsolut, setEntradasAbsolut] = useState([]);
  const [filtrosAplicados, setFiltrosAplicados] = useState([]);
  /* De que unidade são os dados deste ecrã. Arranca na da sessão, porque é
     este o ecrã do fecho do dia: quem fecha a caixa quer o total daquele
     balcão, e um consolidado das duas é um número errado à espera de ser
     conferido contra o dinheiro físico.

     Não é um filtro — muda o PEDIDO. Ver `SeletorUnidadeDados`. */
  const [unidadeDados, setUnidadeDados] = useState(
    () => auth.estabelecimento?._id ?? null,
  );
  const [filtroCaixa, setFiltroCaixa] = useState();
  const [filtroCategoria, setFiltroCategoria] = useState();
  const [filtroMetodoPagamento, setFiltroMetodoPagamento] = useState();
  const [filtroBeneficio, setFiltroBeneficio] = useState();

  const { sendRequest } = useHttpClient();

  const fetchContasCorrentesDespesaEntrada = async (
    startDate,
    endDate,
    unidade = unidadeDados,
  ) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("startDate", startDate);
      formData.append("endDate", endDate);

      /* A unidade vai no PEDIDO. Os três endpoints partilham este FormData,
         por isso recebem forçosamente a mesma — parcelas, despesas e entradas
         do mesmo sítio, que é o que faz o total do fecho bater. */
      for (const [chave, val] of Object.entries(
        paramsUnidadeDados(unidade, auth),
      )) {
        formData.append(chave, String(val));
      }

      const [responseDataCc, responseDespesas, responseDataEntradas] =
        await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/financeiro/daterange/fechocaixa/${clinicaId}`,
            "PATCH",
            formData,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/despesas/clinica/daterange/fluxocaixa/${clinicaId}`,
            "PATCH",
            formData,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/clinica/daterange/fechocaixa/${clinicaId}`,
            "PATCH",
            formData,
            { Authorization: "Bearer " + auth.token },
          ),
        ]);

      const updateState = (data, permission, setState, setAbsoluteState) => {
        if (auth.perm.includes(permission)) {
          setState(data);
          setAbsoluteState(data);
        } else {
          setState([]);
          setAbsoluteState([]);
        }
      };

      updateState(
        responseDataCc.parcelas,
        "r-parc",
        setParcelas,
        setParcelasAbsolut,
      );
      updateState(
        responseDespesas.despesas,
        "r-des",
        setDespesas,
        setDespesasAbsolut,
      );
      updateState(
        responseDataEntradas.entradas,
        "r-ent",
        setEntradas,
        setEntradasAbsolut,
      );

      handleFiltrar(
        responseDataCc.parcelas,
        responseDespesas.despesas,
        responseDataEntradas.entradas,
        [],
        null,
        null,
        null,
        null,
        {
          dataInicial: moment(startDate).format("DD/MM/YYYY"),
          dataFinal: moment(endDate).format("DD/MM/YYYY"),
        },
      );
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const fetchInstituicoes = async () => {
    const instituicoesReponse = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/instituicoes/clinica/nomeOnly/${clinicaId}`,
      "GET",
      null,
      { Authorization: "Bearer " + auth.token },
    );
    setInstituicoes(instituicoesReponse.instituicoes);
  };

  useEffect(() => {
    fetchContasCorrentesDespesaEntrada(
      new Date().toISOString(),
      new Date().toISOString(),
    );

    fetchInstituicoes();
  }, []);

  /* Trocar de unidade é um pedido novo, não um recorte do que já veio.
     O período em curso está em `dataFiltro`, em DD/MM/YYYY — daí o moment
     para o converter de volta ao que o servidor espera. */
  const trocarUnidade = (nova) => {
    setUnidadeDados(nova);
    fetchContasCorrentesDespesaEntrada(
      moment(dataFiltro.dataInicial, "DD/MM/YYYY").toISOString(),
      moment(dataFiltro.dataFinal, "DD/MM/YYYY").toISOString(),
      nova,
    );
  };

  /* No consolidado, cada linha diz de que unidade é. Numa unidade só, não —
     seria a mesma pastilha repetida em todas as linhas. */
  const verTodasUnidades = unidadeDados === TODAS_UNIDADES;

  useEffect(() => {
    let recebido = 0;
    let porReceber = 0;
    let dataParaDataGrid = [];
    let totalDespesas = 0;
    let aPagar = 0;

    let quantiaPorMetodoPagamento = {
      Dinheiro: 0,
      Cheque: 0,
      "Cheque Visado": 0,
      "Transferência de crédito": 0,
      "Internet banking": 0,
      "Cartão do banco": 0,
      "Débito direto da conta bancária": 0,
      "Cartão de crédito": 0,
      "Cartão de débito": 0,
    };

    parcelas.forEach((parcela) => {
      recebido += parcela.quantiaPaga;
      if (parcela.status !== "CANCELADA") {
        porReceber += parcela.quantiaPorPagar;
      }
      if (
        parcela.parcelaPaga &&
        !(parcela.quantiaPorPagar === 0 && parcela.quantiaPaga === 0)
      ) {
        somarAoMetodo(
          quantiaPorMetodoPagamento,
          parcela.metodoPagamento,
          parcela.quantiaPaga,
        );
        dataParaDataGrid.push({
          tipo: "receita",
          cliente: parcela.contaCorrente.cliente.nome,
          idCliente: parcela.contaCorrente.cliente._id,
          dadosCliente: parcela.contaCorrente.cliente,
          idContaCorrente: parcela.contaCorrente._id,
          orcamento: parcela.conta.orcamento,
          id: parcela._id,
          contaId: parcela.conta._id,
          dataLimitePagamento: parcela.dataLimitePagamento,
          dataPagamento: parcela.dataPagamento,
          quantiaPorPagar: parcela.quantiaPorPagar,
          quantiaPaga: parcela.quantiaPaga,
          metodoPagamento: parcela.metodoPagamento,
          entrada: parcela.entrada,
          nrParcela: parcela.nrParcela,
          parcelaPaga: parcela.parcelaPaga,
          nrRecibo: parcela.nrRecibo,
          recebidoPor: parcela.recebidoPor?.name,
          estado: parcela.parcelaPaga
            ? "Pago"
            : moment()
                  .startOf("day")
                  .isAfter(moment(parcela.dataLimitePagamento).startOf("day"))
              ? "Em atraso"
              : "",
          documentoEletronico: parcela.documentoEletronico,
          /* Unidade da linha, para a pastilha do consolidado. Numa parcela
             PAGA é a de quem recebeu; o recurso ao orçamento serve os
             recebimentos anteriores ao carimbo. */
          estabelecimento:
            parcela.estabelecimento ||
            parcela.caixa?.estabelecimento ||
            parcela.conta?.orcamento?.estabelecimento,
          descricao: `${parcela.descricao || "Tratamento dentário"}`,
          valor: parcela.quantiaPaga.toLocaleString("pt-BR"),
          dfe: parcela.documentoEletronico?.nrDocumento || "-",
        });
      }
    });

    if (despesas && despesas.length > 0) {
      despesas.forEach((despesa) => {
        if (!despesa.despesaPaga) aPagar += despesa.valor;
        else {
          somarAoMetodo(
            quantiaPorMetodoPagamento,
            despesa.metodoPagamento,
            -despesa.valor,
          );
          totalDespesas += despesa.valor;
          dataParaDataGrid.push({
            tipo: "despesa",
            id: despesa.id,
            dataLimitePagamento: despesa.dataLimitePagamento,
            dataPagamento: despesa.dataPagamento,
            valor: despesa.valor,
            metodoPagamento: despesa.metodoPagamento,
            despesaPaga: despesa.despesaPaga,
            estabelecimento:
              despesa.estabelecimento || despesa.caixa?.estabelecimento,
            descricao: despesa.descricao,
            comprovativo: despesa.comprovativo,
            pagaPor: despesa.pagaPor?.user?.name,
            estado: despesa.despesaPaga
              ? "Pago"
              : moment()
                    .startOf("day")
                    .isAfter(moment(despesa.dataLimitePagamento).startOf("day"))
                ? "Em atraso"
                : "",
          });
        }
      });
    }

    if (entradas && entradas.length > 0) {
      entradas.forEach((entrada) => {
        if (!entrada.entradaRecebida) {
          porReceber += entrada.valor;
        } else {
          recebido += entrada.valor;
          somarAoMetodo(
            quantiaPorMetodoPagamento,
            entrada.metodoPagamento,
            entrada.valor,
          );
          dataParaDataGrid.push({
            tipo: "entrada",
            tipoEntrada: entrada.tipo,
            id: entrada.id,
            cliente: entrada.cliente
              ? entrada.cliente
              : entrada.clienteFornecedor,
            dadosCliente: entrada.cliente
              ? entrada.cliente
              : entrada.clienteFornecedor,
            dataPagamento: entrada.dataPagamento,
            valor: entrada.valor,
            metodoPagamento: entrada.metodoPagamento,
            estabelecimento:
              entrada.estabelecimento || entrada.caixa?.estabelecimento,
            descricao: entrada.descricao,
            comprovativo: entrada.comprovativo,
            estado: "Pago",
            documentoEletronico: entrada.documentoEletronico,
            recebidoPor: entrada.recebidoPor?.name,
            nrRecibo: entrada.nrRecibo,
            dfe: entrada.documentoEletronico?.nrDocumento || "-",
            rce:
              entrada.faturaEReciboEletronicos?.rce?.succeeded === true
                ? entrada.faturaEReciboEletronicos.rce
                : null,
          });
        }
      });
    }

    dataParaDataGrid = dataParaDataGrid.sort(
      (a, b) => new Date(a.dataPagamento) - new Date(b.dataPagamento),
    );

    let saldo = 0;
    let finalDataParaDataGrid = [];

    dataParaDataGrid.forEach((dt) => {
      if (dt.tipo === "despesa") {
        saldo -= dt.valor;
      } else if (dt.tipo === "receita") {
        saldo += dt.quantiaPaga;
      } else {
        saldo += dt.valor;
      }

      finalDataParaDataGrid.push({
        ...dt,
        saldo: saldo.toLocaleString("pt-BR") + "$00",
      });
    });

    setFinancialData({
      totalRecebido: recebido.toLocaleString("pt-BR"),
      totalReceber: porReceber.toLocaleString("pt-BR"),
      totalDespesas: totalDespesas.toLocaleString("pt-BR"),
      totalPorPagar: aPagar.toLocaleString("pt-BR"),
      saldo: (recebido - totalDespesas).toLocaleString("pt-BR"),
    });

    setResumoData(quantiaPorMetodoPagamento);

    setRows(dataGridData(finalDataParaDataGrid));
  }, [parcelas, despesas, entradas]);

  const handleFiltrar = (
    newParcelas,
    newDespesas,
    newEntradas,
    filtros,
    filtroCai,
    filtroCat,
    filtroMet,
    filtroBen,
    data,
  ) => {
    setFiltroCaixa(filtroCai);
    setFiltroCategoria(filtroCat);
    setFiltroMetodoPagamento(filtroMet);
    setFiltroBeneficio(filtroBen);
    setFiltrosAplicados(filtros);
    if (newParcelas) {
      setParcelas([...newParcelas]);
    }
    if (newDespesas) {
      setDespesas([...newDespesas]);
    }
    if (newEntradas) {
      setEntradas([...newEntradas]);
    }

    if (data !== "modalFiltros") setDataFiltro(data);
  };

  const handleExportar = () => {
    const sheetData = rows.map((r) => {
      return {
        descricao: r.descricao
          ? r.descricao
          : `${r.nome}${r.nrParcela ? " - Parcela " + r.nrParcela : ""}`,
        cliente: r.cliente,
        valor: r.valor,
        tipo: r.tipo,
        estado: r.estado,
        data_Pagamento: r.dataPagamento
          ? moment(r.dataPagamento).format("DD-MM-YYYY")
          : "-",
        dataLimitePagamento: r.dataLimitePagamento
          ? moment(r.dataLimitePagamento).format("DD-MM-YYYY")
          : "-",
        metodoPagamento: r.metodoPagamento ? r.metodoPagamento : "-",
      };
    });

    generateExcelFile(
      `HistoricoFinanceiro ${moment().format("DD-MM-YYYY")}.xlsx`,
      "Financeiro",
      sheetData,
    );
  };

  const imprimirFechoCaixa = () => {
    dadosFechoCaixa({
      rows: rows,
      dataInicial: dataFiltro.dataInicial,
      dataFinal: dataFiltro.dataFinal,
      resumo: resumoData,
      saldo: financialData.saldo,
      titulo: "Fecho de caixa",
    });
  };

  const gerarPdfFaturaEletronicaHandler = async (row) => {
    showFatura({
      show: true,
      // Morada da unidade que EMITIU o documento, não da que está a imprimir.
      clinica: dadosImpressao(
        dadosClinica,
        row.documentoEletronico?.estabelecimento,
      ),
      cliente: {
        nome: row.dadosCliente.nomeFiscal
          ? row.dadosCliente.nomeFiscal
          : row.dadosCliente.nome,
        endereco: row.dadosCliente.endereco,
        contacto: row.dadosCliente.contacto,
        nif: row.dadosCliente.nif,
      },
      metodoPagamento: row.metodoPagamento,
      designacao: row.descricao,
      valor: row.documentoEletronico.valor,
      nrDocumento: row.documentoEletronico.nrDocumento,
      dataDocumento: row.documentoEletronico.authorizedDateTime,
      dataVencimento: row.dataLimitePagamento,
      entryName: row.documentoEletronico.entryName,
      serie: row.documentoEletronico.serie,
      tipoDocumento: row.documentoEletronico.tipoDocumento,
      emitidoEmContingencia: row.documentoEletronico.emitidoEmContingencia,
      usuarioEmissor: row.documentoEletronico.usuarioEmissor?.name,
    });
  };

  const gerarPdfRceHandler = async (id) => {
    let entradaFiltrada;

    entradaFiltrada = entradas.filter((e) => e.id === id)[0];
    showRce({
      show: true,
      // Morada da unidade que EMITIU o recibo, não da que está a imprimir.
      clinica: dadosImpressao(
        dadosClinica,
        entradaFiltrada.faturaEReciboEletronicos?.rce?.estabelecimento,
      ),
      cliente: {
        nome: entradaFiltrada.clienteFornecedor.nome,
        endereco: entradaFiltrada.clienteFornecedor.endereco,
        contacto: entradaFiltrada.clienteFornecedor.contacto,
        nif: entradaFiltrada.clienteFornecedor.nif,
      },
      metodoPagamento: entradaFiltrada.metodoPagamento,
      dataPagamento: entradaFiltrada.dataPagamento,
      designacao: entradaFiltrada.descricao,
      valor: entradaFiltrada.faturaEReciboEletronicos.rce.valor,
      nrDocumento: entradaFiltrada.faturaEReciboEletronicos.rce.nrDocumento,
      dataDocumento:
        entradaFiltrada.faturaEReciboEletronicos.rce.authorizedDateTime,
      entryName: entradaFiltrada.faturaEReciboEletronicos.rce.entryName,
      serie: entradaFiltrada.faturaEReciboEletronicos.rce.serie,
      tipoDocumento: entradaFiltrada.faturaEReciboEletronicos.rce.tipoDocumento,
      emitidoEmContingencia:
        entradaFiltrada.faturaEReciboEletronicos.rce.emitidoEmContingencia,
      referencia: entradaFiltrada.faturaEReciboEletronicos.fte.entryName,
      usuarioEmissor:
        entradaFiltrada.faturaEReciboEletronicos.rce.usuarioEmissor?.name,
    });
  };

  const actionColumn = [
    {
      field: "inOrOut",
      headerName: "",
      width: 30,
      renderCell: (params) => {
        return (
          <>
            {(params.row.tipo === "receita" ||
              params.row.tipo === "entrada") && (
              <CallReceivedIcon className="financeiro__container__cabecalho__totais--icon_div--receita" />
            )}
            {params.row.tipo === "despesa" && (
              <CallMadeIcon className="financeiro__container__cabecalho__totais--icon_div--despesa" />
            )}
          </>
        );
      },
    },
    {
      field: "data",
      headerName: "Data",
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            {params.row.tipo === "receita" && (
              <span className="spanCellPago">
                {moment(params.row.dataPagamento).format("DD-MM-YYYY")}
              </span>
            )}

            {params.row.tipo === "despesa" && (
              <span className="spanCellAtraso">
                {moment(params.row.dataPagamento).format("DD-MM-YYYY")}
              </span>
            )}

            {params.row.tipo === "entrada" && (
              <span className="spanCellPago">
                {moment(params.row.dataPagamento).format("DD-MM-YYYY")}
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: "nome",
      headerName: "Descrição",
      flex: 5,
      renderCell: (params) => {
        return (
          <>
            {params.row.tipo === "receita" && (
              <div className="cellDebitoNome">
                <span className="spanCellPago">
                  {/* Só no consolidado. Numa unidade só, todas as linhas são
                      dela e a pastilha seria ruído repetido. */}
                  {verTodasUnidades && (
                    <BadgeUnidade
                      estabelecimento={params.row.estabelecimento}
                      prefixo="Recebido em"
                    />
                  )}{" "}
                  {params.row.nome}{" "}
                  <Link
                    /* Aos débitos, e não à ficha: quem vem de uma parcela quer
                       ver a conta. Nas entradas já era assim, e nas receitas
                       também. */
                    to={`/clientes/${params.row.idCliente}-debitos`}
                    className="link-cliente-receita"
                  >
                    {" "}
                    {params.row.cliente}
                  </Link>
                </span>
                {params.row.nrParcela && (
                  <Tooltip
                    title={`Parcelado em ${params.row.nrParcela[2]} vezes`}
                  >
                    <IconButton>
                      <span className="nrParcela">{params.row.nrParcela}</span>
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            )}

            {params.row.tipo === "entrada" && (
              <div className="spanCellPago">
                {verTodasUnidades && (
                  <BadgeUnidade
                    estabelecimento={params.row.estabelecimento}
                    prefixo="Registada em"
                  />
                )}{" "}
                {params.row.descricao}
                {params.row.cliente && (
                  <>
                    {" - "}

                    {params.row.tipoEntrada === "reembolso" ? (
                      <Link
                        to={`/clientes/${params.row.cliente._id}-debitos`}
                        className="link-cliente-receita"
                      >
                        {" "}
                        {params.row.cliente.nome}
                      </Link>
                    ) : (
                      params.row.cliente.nome
                    )}
                  </>
                )}
              </div>
            )}

            {params.row.tipo === "despesa" && (
              <div className="spanCellAtraso">
                {verTodasUnidades && (
                  <BadgeUnidade
                    estabelecimento={params.row.estabelecimento}
                    prefixo="Paga em"
                  />
                )}{" "}
                {params.row.descricao}
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "recebidPor",
      headerName: "Recebido/Pago por",
      flex: 3,
      renderCell: (params) => {
        return (
          <>
            {(params.row.tipo === "receita" ||
              params.row.tipo === "entrada") && (
              <div className="cellDebitoNome">
                <span>{params.row.recebidoPor}</span>
              </div>
            )}

            {params.row.tipo === "despesa" && <div>{params.row.pagaPor}</div>}
          </>
        );
      },
    },
    {
      field: "estado",
      headerName: "Pagamento",
      flex: 2,
      renderCell: (params) => {
        return (
          <>
            {params.row.tipo === "receita" && (
              <div className="cellDebitoEstado">
                <span>{params.row.metodoPagamento}</span>
              </div>
            )}

            {params.row.tipo === "despesa" && (
              <div className="cellDebitoEstado">
                <span>{params.row.metodoPagamento}</span>
              </div>
            )}

            {params.row.tipo === "entrada" && (
              <div className="cellDebitoEstado">
                <span>{params.row.metodoPagamento}</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "dfe",
      headerName: "DFE",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {(params.row.tipo === "receita" ||
              params.row.tipo === "entrada") && (
              <div className="cellDebitoNome">
                <span>
                  {`${params.row.dfe}${params.row.rce ? "/RCE" : ""}` || "-"}
                </span>
              </div>
            )}

            {params.row.tipo === "despesa" && <div>-</div>}
          </>
        );
      },
    },
    {
      field: "valor",
      headerName: "Valor",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {params.row.tipo === "receita" && (
              <div className="cellAction">
                <span
                  className="debitos__container__valor--pago"
                  style={{ marginLeft: "auto" }}
                >
                  {params.row.valor}
                </span>
              </div>
            )}

            {(params.row.tipo === "despesa" ||
              params.row.tipo === "entrada") && (
              <span
                className={
                  params.row.tipo === "despesa"
                    ? "spanCellAtraso"
                    : "spanCellPago"
                }
              >
                {params.row.tipo === "despesa" ? "-" : ""}
                {params.row.valor}
              </span>
            )}
          </>
        );
      },
    },
    {
      field: "saldo",
      headerName: "Saldo",
      flex: 1,
      renderCell: (params) => {
        return <span>{params.row.saldo}</span>;
      },
    },
    {
      field: "action",
      headerName: "Ações",
      flex: 1,
      renderCell: (params) => {
        let content = [];
        if (params.row.documentoEletronico?.succeeded) {
          content.push(
            <div className="dots__menu__popup" key="pdf1">
              <div
                className="popOverMenu--option"
                onClick={gerarPdfFaturaEletronicaHandler.bind(null, params.row)}
              >
                <span>
                  Gerar PDF {params.row.documentoEletronico?.tipoDocumento}
                </span>
                <ArticleOutlinedIcon className="popOverMenu--option__icon" />
              </div>
            </div>,
          );
        }
        if (params.row.rce) {
          content.push(
            <div className="dots__menu__popup" key="pdf2">
              <div
                className="popOverMenu--option"
                onClick={gerarPdfRceHandler.bind(null, params.row.id)}
              >
                <span>Gerar PDF RCE</span>
                <ArticleOutlinedIcon className="popOverMenu--option__icon" />
              </div>
            </div>,
          );
        }

        return (
          <>
            {content && (
              <Popover content={content} trigger="click" placement="bottom">
                <div className="dots__menu">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </Popover>
            )}
          </>
        );
      },
    },
  ];

  return (
    <div className="financeiro__container caixa">
      <div className="financeiro__adicionarEFiltros">
        <FiltrosFinanceiro
          parcelas={parcelasAbsolut}
          despesas={despesasAbsolut}
          entradas={entradasAbsolut}
          handleFiltrar={handleFiltrar}
          handleExportar={handleExportar}
          filtrosAplicados={filtrosAplicados}
          filtroCaixa={filtroCaixa}
          filtroCategoria={filtroCategoria}
          filtroMetodoPagamento={filtroMetodoPagamento}
          filtroBeneficio={filtroBeneficio}
          clinicaId={clinicaId}
          auth={auth}
          fetchContasCorrentesDespesaEntrada={
            fetchContasCorrentesDespesaEntrada
          }
          imprimirFechoCaixa={imprimirFechoCaixa}
          instituicoes={instituicoes}
        />
      </div>

      <SeletorUnidadeDados valor={unidadeDados} onChange={trocarUnidade} />

      <div className="financeiro__container__cabecalho">
        <div className="financeiro__container__cabecalho__totais">
          <div className="financeiro__container__cabecalho__totais--recebido">
            <div className="financeiro__container__cabecalho__totais__firstContainer financeiro__container__cabecalho__totais__firstContainer--recebido">
              <div className="financeiro__container__cabecalho__totais--icon_div">
                <span className="financeiro__container__cabecalho__totais--titulos">
                  Receitas
                </span>
                <CallReceivedIcon className="financeiro__container__cabecalho__totais--icon_div--receita" />
              </div>
              <div className="financeiro__container__cabecalho__totais--texto">
                <span className="financeiro__container__cabecalho__totais--recebido--valor_principal">
                  {financialData.totalRecebido}$00
                </span>
                <span className="financeiro__container__cabecalho__totais--texto--info">
                  A receber {financialData.totalReceber}$00
                </span>
              </div>
            </div>
          </div>
          <span className="financeiro__container__cabecalho__totais--separador">
            -
          </span>
          <div className="financeiro__container__cabecalho__totais--por-receber">
            <div className="financeiro__container__cabecalho__totais__firstContainer financeiro__container__cabecalho__totais__firstContainer--por-receber">
              <div className="financeiro__container__cabecalho__totais--icon_div">
                <span className="financeiro__container__cabecalho__totais--titulos">
                  Despesas
                </span>
                <CallMadeIcon className="financeiro__container__cabecalho__totais--icon_div--despesa" />
              </div>
              <div className="financeiro__container__cabecalho__totais--texto">
                <span className="financeiro__container__cabecalho__totais--por-receber--valor_principal">
                  {financialData.totalDespesas}$00
                </span>
                <span className="financeiro__container__cabecalho__totais--texto--info">
                  A pagar {financialData.totalPorPagar}$00
                </span>
              </div>
            </div>
          </div>
          <span className="financeiro__container__cabecalho__totais--separador">
            =
          </span>
          <div className="financeiro__container__cabecalho__totais--saldo">
            <div className="financeiro__container__cabecalho__totais__firstContainer financeiro__container__cabecalho__totais__firstContainer--saldo">
              <span className="financeiro__container__cabecalho__totais--titulos">
                Saldo
              </span>
              <div className="financeiro__container__cabecalho__totais--texto">
                <span className="financeiro__container__cabecalho__totais--saldo--valor_principal">
                  {financialData.saldo}$00
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {rows && (
        <div style={{ height: 635, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={actionColumn}
            pageSize={10}
            rowsPerPageOptions={[10]}
          />
        </div>
      )}

      <div className="fluxoCaixa__resumo__container">
        <div className="fluxoCaixa__resumo__cabecalho">
          {dataFiltro === "todos"
            ? "Resumo Total"
            : `Resumo de ${dataFiltro.dataInicial}  a ${dataFiltro.dataFinal}`}
        </div>

        <div className="fluxoCaixa__resumo__body">
          <span className="fluxoCaixa__resumo__title">
            Totais por meio de Pagamento
          </span>
          <div className="fluxoCaixa__resumo__list">
            <div className="fluxoCaixa__resumo__list__left">
              {Object.entries(resumoData)
                .slice(0, 5)
                .map(([key, value]) => (
                  <div
                    className="fluxoCaixa__resumo__list__left__item"
                    key={key}
                  >
                    <span>{key}</span>
                    <span>{value.toLocaleString("pt-BR")}$00</span>
                  </div>
                ))}
            </div>
            <div className="fluxoCaixa__resumo__list__right">
              {Object.entries(resumoData)
                .slice(5)
                .map(([key, value]) => (
                  <div
                    className="fluxoCaixa__resumo__list__right__item"
                    key={key}
                  >
                    <span>{key}</span>
                    <span>{value.toLocaleString("pt-BR")}$00</span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FechoCaixa;
